import { AppRegion } from "@src/runtime-config-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import USFlagIcon from "@assets/icons/us-flag_24px.svg?react";
import EUFlagIcon from "@assets/icons/eu-flag_24px.svg?react";

/** Maps the server identifier to a user-friendly label */
export const SERVER_IDENTIFIER_LABEL: Record<
  FaroCoreApiTypes.ServerIdentifier,
  string
> = {
  ["sphere_2_com"]: "US Server",
  ["sphere_2_eu"]: "EU Server",
};

/** Maps the server identifier to its corresponding icon */
export const SERVER_IDENTIFIER_ICON: Record<
  FaroCoreApiTypes.ServerIdentifier,
  JSX.Element
> = {
  ["sphere_2_com"]: <USFlagIcon />,
  ["sphere_2_eu"]: <EUFlagIcon />,
};

/** Maps the application region to it's corresponding server identifier */
export const REGION_SERVER_IDENTIFIER: Record<
  AppRegion,
  FaroCoreApiTypes.ServerIdentifier
> = {
  com: "sphere_2_com",
  eu: "sphere_2_eu",
};
